import React from 'react';
export var Calculator = function Calculator() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 81 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9031 9.8936C53.9716 8.9663 60.274 11.8754 64.3498 17.2345C68.4635 22.6434 70.3697 30.6217 71.4273 39.9637C73.5092 58.3522 58.9356 74.8266 38.7693 76.6838C28.7109 77.6102 21.7505 74.4854 17.0259 68.8773C12.2759 63.2391 9.73704 55.0329 8.68283 45.7214C6.60764 27.3918 23.6682 11.7572 43.9031 9.8936Z",
    fill: "#F9F9F9",
    stroke: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "21.8411",
    y: "18.1198",
    width: "37.9027",
    height: "48.7626",
    rx: "1.44645",
    fill: "white",
    stroke: "#143F3D",
    strokeWidth: "1.44645"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "26.3445",
    y: "22.6025",
    width: "28.8962",
    height: "9.39907",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "26.3445",
    y: "22.6025",
    width: "28.8962",
    height: "9.39907",
    rx: "1",
    fill: "#F9F9F9",
    stroke: "#143F3D",
    strokeWidth: "2.4",
    mask: "url(#path-3-inside-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0984 14.5467L16.0984 36.3759",
    stroke: "#43EE91",
    strokeWidth: "1.66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "27.4189",
    y: "36.1617",
    width: "6.37934",
    height: "6.5827",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "27.4189",
    y: "36.1617",
    width: "6.37934",
    height: "6.5827",
    rx: "1",
    fill: "#F9F9F9",
    stroke: "#143F3D",
    strokeWidth: "2.4",
    mask: "url(#path-5-inside-2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "27.4192",
    y: "45.5363",
    width: "6.37934",
    height: "6.5827",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "27.4192",
    y: "45.5363",
    width: "6.37934",
    height: "6.5827",
    rx: "1",
    fill: "#F9F9F9",
    stroke: "#143F3D",
    strokeWidth: "2.4",
    mask: "url(#path-6-inside-3)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "27.4192",
    y: "54.9054",
    width: "6.37934",
    height: "6.5827",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "27.4192",
    y: "54.9054",
    width: "6.37934",
    height: "6.5827",
    rx: "1",
    fill: "#F9F9F9",
    stroke: "#143F3D",
    strokeWidth: "2.4",
    mask: "url(#path-7-inside-4)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "37.6028",
    y: "36.1617",
    width: "6.37934",
    height: "6.5827",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "37.6028",
    y: "36.1617",
    width: "6.37934",
    height: "6.5827",
    rx: "1",
    fill: "#F9F9F9",
    stroke: "#143F3D",
    strokeWidth: "2.4",
    mask: "url(#path-8-inside-5)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47.7866",
    y: "36.1617",
    width: "6.37934",
    height: "6.58269",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47.7866",
    y: "36.1617",
    width: "6.37934",
    height: "6.58269",
    rx: "1",
    fill: "#F9F9F9",
    stroke: "#143F3D",
    strokeWidth: "2.4",
    mask: "url(#path-9-inside-6)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "37.603",
    y: "45.5363",
    width: "6.37934",
    height: "6.5827",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "37.603",
    y: "45.5363",
    width: "6.37934",
    height: "6.5827",
    rx: "1",
    fill: "#F9F9F9",
    stroke: "#143F3D",
    strokeWidth: "2.4",
    mask: "url(#path-10-inside-7)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47.7866",
    y: "45.5363",
    width: "6.37934",
    height: "6.5827",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47.7866",
    y: "45.5363",
    width: "6.37934",
    height: "6.5827",
    rx: "1",
    fill: "#F9F9F9",
    stroke: "#143F3D",
    strokeWidth: "2.4",
    mask: "url(#path-11-inside-8)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "37.603",
    y: "54.9053",
    width: "6.37934",
    height: "6.58269",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "37.603",
    y: "54.9053",
    width: "6.37934",
    height: "6.58269",
    rx: "1",
    fill: "#F9F9F9",
    stroke: "#143F3D",
    strokeWidth: "2.4",
    mask: "url(#path-12-inside-9)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47.7866",
    y: "54.9053",
    width: "6.37934",
    height: "6.5827",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47.7866",
    y: "54.9053",
    width: "6.37934",
    height: "6.5827",
    rx: "1",
    fill: "#F9F9F9",
    stroke: "#143F3D",
    strokeWidth: "2.4",
    mask: "url(#path-13-inside-10)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "10.4377",
    y1: "23.7935",
    x2: "10.4377",
    y2: "38.5988",
    stroke: "#43EE91",
    strokeWidth: "1.66",
    strokeLinecap: "round"
  }));
};